import { Component } from '@angular/core';

@Component({
    selector: 'pickright-error',
    templateUrl: './control-error.component.html'
})
export class PickrightErrorComponent {

}
